import { getFormattedDate } from '../../utils/utils';
import { orderStatus, quoteStatus } from '../../utils/constant';

const getStatus = statusCode => {
  switch (statusCode) {
    case orderStatus.incomplete:
      return 'Order Incomplete';
    case quoteStatus.approved:
      return 'Quote Approved';
    case orderStatus.contractSent:
      return 'Contract Sent';
    case orderStatus.contractSigned:
      return 'Contract Signed';
    case orderStatus.orderSubmitted:
      return 'Order Submitted';
    case orderStatus.contractExpired:
      return 'Contract Expired';
    case orderStatus.orderCanceled:
      return 'Commande annulée';
    default:
      return statusCode;
  }
};

/* eslint-disable camelcase */
class OrderListModel {
  constructor(data) {
    const {
      createdAt,
      contractExpired,
      channel,
      channels,
      businessLegalName,
      productInOrderFor,
      typeOfInstallation,
      orderId,
      validatedAt,
      orderAssignedTo,
      name,
      status,
      orderComments
    } = data || {};
    const getChannelName = () => {
      if (channels && channels.length) {
        return channels[0].name;
      }
      return (channel && channel.name) || '-';
    };

    this.createdAt = getFormattedDate(createdAt, 'YYYY-MM-DD');
    this.orderStatus = getStatus(status) || '-';
    this.contractExpired = contractExpired;
    this.channel = getChannelName();
    this.businessLegalName = businessLegalName;
    this.product = productInOrderFor;
    this.typeOfInstallation = typeOfInstallation || 'New';
    this.orderId = orderId;
    this.completedAt =
      (validatedAt && getFormattedDate(validatedAt, 'YYYY-MM-DD')) || '-';
    this.orderAssignedTo =
      (orderAssignedTo &&
        `${orderAssignedTo.first_name} ${orderAssignedTo.last_name}`) ||
      '-';
    this.name = name;
    this.comments = orderComments;
  }
}

export class OrderHeaderModel {
  constructor(data) {
    const {
      orderId,
      channel,
      businessLegalName,
      typeOfInstallation,
      createdAt,
      orderStatus: orderStatusHeader,
      actions,
      orderProduct,
      salesRepName
    } = data || {};
    this.orderId = orderId;
    this.channel = channel;
    this.name = salesRepName;
    this.businessLegalName = businessLegalName;
    this.product = orderProduct;
    this.typeOfInstallation = typeOfInstallation;
    this.createdAt = createdAt;
    this.orderStatus = orderStatusHeader;
    this.actions = actions;
  }
}
export class TypeAheadModel {
  constructor(value) {
    return { label: value, id: value };
  }
}

export class RepModel {
  constructor(data) {
    const { name, id } = data || {};
    return { label: name, id };
  }
}

export class UsersListModel {
  constructor(data) {
    const { id, first_name, last_name, email } = data || {};
    return { label: `${first_name} ${last_name} (${email})`, id };
  }
}

export class ChannelModel {
  constructor(data) {
    const { description, id } = data || {};
    this.text = description;
    this.value = id;
  }
}

export class DealershipModel {
  constructor(data) {
    const { name, id } = data || {};
    this.text = name;
    this.value = id;
  }
}

export const getOptions = (list, Model) => {
  return list && list.map(element => new Model(element));
};

export default OrderListModel;
